/**
 * The expandable tags of the expedition list's "additional info": which of them are expanded is
 * remembered per user (localStorage `EXPEDITION_LIST_EXPANDED_INFO_TAGS`), for v2 cells and v3 fields alike.
 */
export enum InfoTagEnum {
  ALL = 'all',
  FAVORITE = 'favorite',
  TYPE = 'type',
  CREATED_BY = 'created_by',
  ORDERS = 'orders',
  NOTE = 'note',
  EXTRA_COSTS = 'extraCosts',
  CAR_INFO = 'carInfo',
  STOPS = 'stops',
  INVOICED = 'invoiced',
  ATTACHMENTS = 'attachments',
  TRANSPORT_LEGS = 'transport_legs',
  PAIRING_SYMBOL = 'pairing_symbol',
  TRACKING_NUMBER = 'tracking_number',
  SHIPMENT_TYPE = 'shipment_type',
  CUSTOMS_STATUS = 'customs_status',
  AI_DISPATCHER_CHANGE = 'ai_dispatcher_change',
}
